<template>
  <div class="form-group">
    <label v-if="label" class="form-label">{{label}}
      <i v-if="required" class="far fa-asterisk"></i>
      <span v-if="language" class="language"> ({{language}})</span>
    </label>
    <div v-bind:class="{'is-invalid': invalid}">
      <i v-if="loading" class="fa fa-loading-black-16"></i>
      <template v-else="">
        <select v-bind:name="id"
                v-bind:value="value"
                v-on:change="changed"
                class="form-select"
                v-bind:class="{'is-invalid': invalid}">
          <option v-if="noSelection" v-bind:value="noSelectionValue">
            {{noSelectionLabel}}
          </option>
          <option v-for="(option, i) in options" v-bind:key="i" v-bind:value="option.id" v-bind:disabled="option.disabled">
            {{option.name}}
          </option>
        </select>
      </template>
    </div>
    <local-errors v-bind:value="errors"/>
    <div v-if="help" class="form-text"><slot name="help"></slot></div>
  </div>
</template>

<script>
export default {
  name: "select-one-menu",
  props: ["id", "value", "options", "noSelection", "noSelectionValue", "noSelectionLabel", "errors", "label", "language", "required", "loading"],
  computed: {
    help: function () {
      return !!this.$slots.help;
    },
    invalid: function () {
      return this.errors && this.errors.length > 0;
    }
  },
  methods: {
    changed: function (event) {
      this.$emit("input", event.target.value);
    }
  },
  watch: {
    options: function () {

    }
  }
}
</script>
